import Echo from '../../echo';

export default async function (to, from, next, store) {
    if (!store.getters['chat/connected']) {
        if (!Echo.initialized) {
            await Echo.init(() => {
                store.dispatch('chat/connect');
            });
        } else {
            store.dispatch('chat/connect');
        }
    }

    return true;
};
